importData = function () {
	var objDialog = dialog();
	var domObject = dom();
	var objImport = {};

	// Initialize Growls
	$('#growls').notify();

	objImport.getHermesData = function() {
		var mapId = $('#map-id').val();
		var hermes = {
			'id': +$('#hermes-id').val(),
			'externalMapId': $('#external-map-id').val(),
			'hermesSystem': $('#system-short-name').val(),
			'systemItemId': +$('#approval-process-id').val(),
			'legendId': +$('#legend-id').val()
		};
		return hermes;
	};

	objImport.importCourse = function() {
		var fieldIDs = [];
		var updateTitle = false;
		var hermes = objImport.getHermesData();
		var uncheckedInputs = $('input:checkbox:not(:checked)').toArray();
		var uncheckedIDs = uncheckedInputs.map(function (item) {
			return +item.value;
		});

		if (!app || !app.proposalImportData) {
			throw Error('proposalImportData is not set!');
		}

		var i, importField, isUnchecked;
		for (i = 0; i < app.proposalImportData.length; i++) {
			importField = app.proposalImportData[i];
			isUnchecked = uncheckedIDs.indexOf(importField.id) !== -1;
			if (!isUnchecked && importField.is_importable) {
				fieldIDs.push(importField.id);
			}
		}

		objImport.updateFields(+$('#proposal-id').val(), fieldIDs, hermes);
	};

	objImport.updateFields = function (proposal, fields, hermes) {
		$.ajax({
			type: 'POST',
			url: '/gearman-job.json',
			contentType: 'application/json',
			data: JSON.stringify({
				functionName: 'import_task',
				workload: {
					module_name: 'ProposalImport',
					method_name: 'updateMany',
					method_args: {
						field_ids: fields,
						legend_id: hermes.legendId,
						proposal_id: proposal,
						datastore_id: hermes.id,
						hermes_info: hermes
					}
				}
			}),

			beforeSend: function () {
				window.opener.focus();
				domObject.addLoadingMask('#hermes-content');
			},

			success: function (results) {
				prepareParentData(results.jobHandle);
			}
		});
	};

	objImport.importProgram = function () {
		objImport.importCourse();
	};

	/**
	 * Import a shared core into a proposal's curriculum field.
	 * @param  {Number} datastoreID -- the ID of the datastore item (core)
	 * @param  {Number} proposalID -- the ID of the proposal.
	 */
	objImport.importSharedCore = function (datastoreID, proposalID, legendId) {
		$.ajax({
			type: 'POST',
			url: '/gearman-job.json',
			contentType: 'application/json',
			data: JSON.stringify({
				functionName: 'import_curriculum_field',
				workload: {
					module_name: 'ProposalImport',
					method_name: 'updateCurriculumField',
					method_args: {
						proposal: proposalID,
						datastoreId: datastoreID,
						parent: window.opener.app.cv.collection.root().get('id'),
						legendId: legendId
					}
				}
			}),
			beforeSend: function () {
				window.opener.focus();
				objDom.addLoadingMask('body');
			},
			success: function (results) {
				var parentProposal = window.opener.proposalObject;
				var canEdit = window.opener.canEdit;
				var richText = window.opener.richText;
				var parentBackbone = window.opener.Backbone;
				var ie = isIE();
				// trigger the polling for the background job on the form
				window.opener.importObject.pollForImportStatus(results.jobHandle, '.schema', function() {
					// parentBackbone.trigger('curriculum:resetSchema');
					parentProposal.resetCurriculum(canEdit, richText, 'schema');
					if (ie) {
						window.close();
					}
				});
				if (!ie) {
					window.close();
				}
			}
		});
	};

	/**
	 * Provide polling status for item import
	 * @param  {String} taskId -- the job handle provided by gearman from the background task
	 * @param  {String} selector -- the id or class to mask and provide polling updates
	 * @param  {Function} callback -- the success callback to be executed on completion
	 */
	objImport.pollForImportStatus = function (taskId, selector, callback) {
		var updateCallback = function (results) {
			var status = results.status;
			var datetime = getCurrentDate();

			// task is queued
			if (status.state === 'QUEUED') {
				msg = 'Import is waiting to begin. (last checked ' + datetime + ')';
				objDom.addCustomMask(selector, msg, 50);

			// task is running
			} else if(status.state === 'RUNNING') {
				msg = 'Import is in process. (last checked ' + datetime + ')';
				objDom.addCustomMask(selector, msg, 50);

			// task is finished
			} else if (status.state === 'FINISHED') {
				objDom.removeMask(selector);
				callback && callback();

			} else if (status.state === 'ERROR') {
				objDom.removeMask(selector);
				$('#growls').notify("create","warning-template", {
					title: 'Warning',
					text: 'An error occurred while attempting to import. Please try again or contact a system administrator.'
				});
			}
		};

		pollJobStatus(taskId, updateCallback);
	};

	/**
	 * Perform dom-related work to gather title and errors from popup
	 * and kick off polling on parent proposal
	 * @param  {String} taskId -- the job handle provided by gearman from the background task
	 */
	var prepareParentData = function (taskId) {
		// updateProposalTitle(app.proposalImportData);
		// Trigger the polling for the background job on the form.
		var parentWindow = window.opener,
			parentImport = parentWindow.importObject,
			ie = isIE();

		parentWindow.objDom.addLoadingMask('#curriculog-fields-column-content');
		parentImport.pollForImportStatus(taskId, '#curriculog-fields-column-content', function () {
			parentImport.reloadProposal().done(function() {
				if (ie) {
					window.close();
				}
			});
		});
		if (!ie) {
			window.close();
		}
	};

	var getErrorMessages = function (importData) {
		var i, importField, errors = {};
		for (i = 0; i < importData.length; i++) {
			importField = importData[i];

			if (importField.errors.length) {
				errors[importField.id] = importField.errors;
			}

			if (importField.warnings.length) {
				errors[importField.id] = importField.warnings;
			}
		}
		return errors;
	};

	var appendErrorMessage = function (fieldID, message) {
		var field_view = app.formView.getField(fieldID);

		// If this is a normal field with a backbone view/model
		if (field_view) {
			var field_model = field_view.model;
			field_view.showError(field_model, message, {clear: false});
			return;
		}

		// Otherwise, default to legacy code. (currently for assments and curriculum)
		var errorMessage = '<span class="error import-error">' + message + '</span><br>';
		// :last selector is for widgets to grab the last text area in the set,
		// and should not affect regular fields.
		var fieldEl = $('.section-fieldset.field-' + fieldID + ' .option-groups:last');
		fieldEl.append(errorMessage);
	};

	/**
	 * appends validation errors below the proposal field.
	 * @param  {Object} errorMessagesPerField -- an object like, {123: ['message1', message2]},
	 *                                         where the key is the proposal field id.
	 */
	var appendErrorMessages = function (errorMessagesPerField) {
		_.each(errorMessagesPerField, function(messages, fieldID) {
			_.each(messages, function(message) {
				appendErrorMessage(fieldID, message);
			});
		});
	};

	/**
	 * Callback to reload the proposal fields and steps and apply field errors from import
	 * @param  {Array} errorMessages -- Array of errors (key of field id)
	 */
	objImport.reloadProposal = function () {
		var defer = $.Deferred();
		// reload steps
		proposalObject.ajaxTab('history');
		// reload the form
		app.formView.getForm().done(function () {
			var errorMessages = getErrorMessages(window.app.proposalImportData);
			appendErrorMessages(errorMessages);
			defer.resolve();
		});
		return defer.promise();
	};

	/***
	 * TODO: Refocus this to proposalfield for import
	 * finalizeCart
	 * processes the courses that they added to the cart and adds them to the curriculum
	 */
	objImport.finalizeCourseCart = function () {
		var courses = $('#hermes-course-cart-content li').map(function () {
			var li = $(this);
			return {
				Prefix: li.find('input[name="title1"]').val(),
				Code: li.find('input[name="title2"]').val(),
				Name: li.find('input[name="title3"]').val(),
				Credits: li.find('input[name="credits"]').val(),
				Status: li.find('input[name="status"]').val(),
				updateCurriculumBucket: true,
				hermes_type: 'course' // FIXME: don't use the hermes_type key
			};
		}).toArray();

		var data = {
			data: courses,
			proposal: window.opener.$('#proposalId').val()
		};


		$.ajax({
			type: 'POST',
			url: '/gearman-job.json',
			contentType: 'application/json',
			data: JSON.stringify({
				functionName: 'import_curriculum_bucket',
				workload: {
					module_name: 'ProposalImport',
					method_name: 'updateCurriculumBucket',
					method_args: {
						data: courses,
						proposal: +window.opener.$('#proposalId').val(),
						legendId: +$('#legend-id').val()
					}
				}
			}),
			beforeSend: function () {
				window.opener.focus();
			},
			success: function (results) {
				var proposalObject = window.opener.proposalObject;
				var canEdit = window.opener.canEdit;
				var richText = window.opener.richText;
				// var app = window.opener.app;
				var ie = isIE();
				// trigger the polling for the background job on the form
				window.opener.importObject.pollForImportStatus(results.jobHandle, '.curriculum', function () {
					// app.curricula.resetData();
					proposalObject.resetCurriculum(canEdit, richText, 'courses');
					if (ie) {
						window.close();
					}
				});
				if (!ie) {
					window.close();
				}
			}
		});
	};

	/**
	 *  exportProposal
	 *  mark proposal with export date to prepare it for hermes
	 */
	objImport.exportProposal = function (proposalId){
		objImport.confirmExportProposal(proposalId);
		$.ajax({
			url: '/proposal/export.json',
			type: 'put',
			data: {
				proposalId: proposalId,
				sync: true
			},
			beforeSend: function() {
				// Add progress icon
				objDom.addLoadingMask('#detail-' + proposalId);
			},
			success: function(){
				Backbone.trigger('listItem:checkPage');
			}
		});
	};
	
	
	/**
	 *  toggleExportProposal
	 *  Toggle marking proposal with export date to prepare it for hermes 
	 * - i.e reset export date to default (null) if currently set to any date
	 * - reset to now() if currently null
	 */
	objImport.toggleExportProposal = function (proposalId){
		return $.ajax({
			url: '/proposal/export.json',
			type: 'put',
			data: {
				proposalId: proposalId,
				sync: true,
				toggle: true
			},
			beforeSend: function() {
				// Add progress icon
				objDom.addLoadingMask('#detail-' + proposalId);
			},
			success: function(){
				Backbone.trigger('listItem:checkPage');
			}
		});
	};
	
	/** Dialog **/
	objImport.confirmExportProposal = function(proposalId) {				
		
		var currently_unchecked = $('#detail-'+proposalId).find('button.action-export').first().hasClass('unchecked');
		if (currently_unchecked) {
			msg = 'You are marking this proposal to be exported. Are you sure you want to continue?';
		} else {
			msg = 'This proposal has been marked Ready for Export previously; you are undoing this action. If this proposal has already been exported via the Integration Manager this action will not impact the previous export.';
		}

		new ProposalsDialog({
			proposalId: proposalId,
			message: msg,
			buttons: function() {
				var buttons = {};
				buttons['Continue'] = 'toggleExportProposal';
				buttons['Cancel']= 'cancel';
				return buttons;
			}
		});		
	};
	

	var ProposalsDialog = Curriculog.WarningDialog.extend({
		buttons: {
			'Cancel': 'cancel'
		},
		cancel: function () {
			this.close();
		},
		toggleExportProposal: function () {
			objImport.toggleExportProposal(this.proposalId);
			this.close();
		}
	});


	return objImport;
};
